import { render, staticRenderFns } from "./PersonalCertificate.vue?vue&type=template&id=167d107f"
import script from "./PersonalCertificate.vue?vue&type=script&lang=js"
export * from "./PersonalCertificate.vue?vue&type=script&lang=js"
import style0 from "./PersonalCertificate.vue?vue&type=style&index=0&id=167d107f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports